"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var mobx_react_1 = require("mobx-react");
var App_1 = require("../../App");
var react_tabs_1 = require("react-tabs");
var DataListToolbar_1 = require("../dataList/DataListToolbar");
var DataListTable_1 = require("../dataList/DataListTable");
var filters_1 = require("./filters");
var ObservationsList = (function (_super) {
    __extends(ObservationsList, _super);
    function ObservationsList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.clickHandler = function (event, url, popup) {
            if (popup) {
                window.open(url + window.location.search);
            }
            else {
                window.location.href = url;
            }
        };
        return _this;
    }
    ObservationsList.prototype.render = function () {
        var data = App_1.store.observationslist.data;
        return (React.createElement(react_tabs_1.Tabs, { selectedTabClassName: "active", selectedIndex: 0 },
            React.createElement(react_tabs_1.TabList, { className: "nav nav-tabs risk_list_tabs" },
                React.createElement(react_tabs_1.Tab, { className: "nav-item" },
                    React.createElement("a", { className: "nav-link" }, gettext("Observations")))),
            React.createElement(react_tabs_1.TabPanel, null,
                React.createElement("div", { className: "ObservationsList" },
                    React.createElement("div", { className: "Div--Background rounded px-3 pb-4 pt-1" },
                        React.createElement(DataListToolbar_1.default, { html_id: "observations", data_list: App_1.store.observationslist, filter_component: filters_1.ObservationsFilter, bulk_edit_label: gettext("Edit observations"), read_only: data.read_only, has_business_model: data.has_business_model, clickHandler: this.clickHandler, rows_counter: data.paginator.items }),
                        React.createElement(DataListTable_1.DataListTable, { html_id: "observations", bulk_update_param: "observations", data_list: App_1.store.observationslist }))))));
    };
    ObservationsList = __decorate([
        mobx_react_1.observer
    ], ObservationsList);
    return ObservationsList;
}(React.Component));
exports.default = ObservationsList;
